/**
 * Release 26: the first module main.tsx evaluates. On the old address a device holding no SATU
 * data goes at once to the same page on the new address (./alamat `arahAwal`), before the
 * address is touched (./buangFragmenSesi keeps an e-mail link's query for the new page then),
 * and before the device database is opened, so nothing is left behind on the old origin.
 */
import { arahAwal, penyimpananPeramban } from './alamat'

function arahkan(): boolean {
  if (typeof window === 'undefined') return false
  const tujuan = arahAwal(window.location, penyimpananPeramban())
  if (tujuan === null) return false
  window.location.replace(tujuan)
  return true
}

/** True while this page is leaving for the new address: nothing else starts. */
export const SEDANG_PINDAH = arahkan()
